// extracted by mini-css-extract-plugin
export default {"TempMessage":"TempMessage_TempMessage__r8MuV","title":"TempMessage_title__WFmRD","messageContainer":"TempMessage_messageContainer__258lm"};